export const WaveformMark = ({ className = "" }) => {
  const bars = [12, 20, 30, 42, 34, 26, 18, 12];
  return (
    <svg
      viewBox="0 0 44 28"
      className={className}
      aria-hidden="true"
      fill="currentColor"
    >
      {bars.map((h, i) => {
        const x = 1.5 + i * 5.5;
        const half = h / 2 - 1.5;
        return (
          <g key={i}>
            <rect x={x} y={14 - h / 2} width="3" height={half} rx="1.5" />
            <rect x={x} y={15.5} width="3" height={half} rx="1.5" />
          </g>
        );
      })}
    </svg>
  );
};
